import React from "react";

interface ConfirmModalProps {
  title?: string;
  children?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  title = "Konfirmasi",
  children,
  confirmLabel = "Ya",
  cancelLabel = "Batal",
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onCancel} />
      <div className="relative w-11/12 max-w-md rounded-2xl bg-white p-5 shadow-lg">
        <h3 className="text-sm font-semibold text-slate-900">{title}</h3>
        <div className="mt-2 text-sm text-slate-600">{children}</div>
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" className="rounded-md px-4 py-2 text-sm bg-slate-100" onClick={onCancel}>{cancelLabel}</button>
          <button type="button" className="rounded-md px-4 py-2 text-sm bg-blue-950 text-white" onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
